const mixinThirdLevel = {
  methods: {
    levelThree(modParent = '1') {
      let levelThree = [];
      let modules = this.$store.state.auth.user.all_modules;
      let user_modules = this.$store.state.auth.user.user_modules;
      const moduleId = sessionStorage.getItem('moduleId');
      let newOrderLevelThree = 0;
      modules.forEach((element) => {
        if (
          element.level == 3 &&
          element.parent_module == moduleId &&
          user_modules.includes(element.id)
        ) {
          element.order = newOrderLevelThree++;
          levelThree.push(element);
        }
      });

      sessionStorage.setItem('levelThree', JSON.stringify(levelThree));

      return levelThree;
    },
  },
};

export default mixinThirdLevel;
